export enum DocumentEmailTypeEnum {
    Initial = 1,
    Reminder = 2,
}
